export default __webpack_public_path__ + "static/media/dashboard-icon.9e877967.svg";